import { Flex, Text, View, Pill } from '@smarterservices/smarter-ui';
import { Case } from 'change-case-all';
import { usePlayerStore } from '../../../stores/StoreContext';
import ReadableTime from '../../Common/ReadableTime';
import CONSTANTS from '../../../config/constants';

const NotYetConnected = ({ SessionTrack }) => {
    const overlay = usePlayerStore((state) => state.overlay);
    const isLive = usePlayerStore((state) => state.isLive);
    const currentTime = usePlayerStore((state) => state.currentTime);
    const jumpTo = usePlayerStore((state) => state.jumpTo);
    const displayVideoLabels = usePlayerStore((state) => state.displayVideoLabels);

    const JUMP_TO_CONNECTION_TIME_OFFSET = 0;

    if (overlay === CONSTANTS.OVERLAYS.PLAYBACK_COMPLETE && !isLive) {
        return null;
    }

    // Find the first 'online' status to determine when the track will connect
    let connectionTime = null;
    if (SessionTrack?.hls?.track?.statuses) {
        const firstOnlineStatus = SessionTrack.hls.track.statuses.find(
            status => status.status === 'online'
        );
        if (firstOnlineStatus) {
            connectionTime = firstOnlineStatus.sessionChangeTime;
        }
    }

    // Calculate time until connection
    const timeUntilConnection = connectionTime !== null ? connectionTime - currentTime : null;

    const handleJumpToConnection = () => {
        if (connectionTime !== null) {
            // Jump to 5 seconds before connection time
            const targetTime = Math.max(0, connectionTime - JUMP_TO_CONNECTION_TIME_OFFSET);
            jumpTo(targetTime);
        }
    };

    return (
        <Flex
            direction="column"
            alignItems="center"
            justifyItems="center"
            height="100%"
        >
            <View as="div" textAlign="center">
                {displayVideoLabels === 'hide' &&
                    <View as="div" margin="none none small none">
                        <Text as="p" textAlign="center" variant="contentImportant" color="primary-inverse">
                            {Case.capital(SessionTrack.name)}
                        </Text>
                    </View>
                }
                <Text as="p" textAlign="center" variant="legend" color="primary-inverse">
                    Not Connected Yet
                </Text>
                {timeUntilConnection !== null && timeUntilConnection > 0 && (
                    <View as="div" margin="small none none">
                        <Text as="p" textAlign="center" variant="legend" color="primary-inverse">
                            Connects in <ReadableTime seconds={timeUntilConnection} />
                        </Text>
                        {/* Force this not to show for now. */}
                        {(timeUntilConnection > 5 && 0 === 1) && (
                            <View as="div" margin="small none none none" textAlign="center">
                                <Pill
                                    color="primary"
                                    onClick={handleJumpToConnection}
                                    cursor="pointer"
                                >
                                    <Text variant="legend">Jump To Time</Text>
                                </Pill>
                            </View>
                        )}
                    </View>
                )}
            </View>
        </Flex>
    );
}
export default NotYetConnected;